import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { storage } from '../lib/api';
import { queryKeys } from './queryKeys';

export function useStorage(prefix?: string) {
  return useQuery({
    queryKey: queryKeys.storage.list(prefix),
    queryFn: () => storage.list(prefix),
  });
}

export function useDeleteStorageFile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => storage.deleteFile(key),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.storage.all }),
  });
}

export function useBulkDeleteStorage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (keys: string[]) => storage.bulkDelete(keys),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.storage.all }),
  });
}
